const moduleRoutes = [
    {
        path: '/retail',
        name: 'retails',
        children: [
            {
                path: '',
                name: 'retailList',
                component: () => import('@/modules/retail/list/List.vue'),
                meta: {
                    resource: 'retails',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Retails',
                    breadcrumbs: [{ title: 'Retail List', routeName: 'retailList' }]
                }
            },
            {
                path: 'new',
                name: 'retailNew',
                component: () => import('@/modules/retail/entry/New.vue'),
                meta: {
                    resource: 'retails',
                    action: 'create',
                    layout: 'default',
                    auth: true,
                    title: 'New Retail',
                    breadcrumbs: [
                        { title: 'Retail List', routeName: 'retailList' },
                        { title: 'New', routeName: 'retailNew' }
                    ]
                }
            },
            {
                path: ':id/edit',
                name: 'retailEdit',
                component: () => import('@/modules/retail/entry/Edit.vue'),
                meta: {
                    resource: 'retails',
                    action: 'edit',
                    layout: 'default',
                    auth: true,
                    title: 'Edit Retail',
                    breadcrumbs: [
                        { title: 'Retail List', routeName: 'retailList' },
                        { title: 'Edit', routeName: 'retailEdit' }
                    ]
                }
            }
        ]
    }
]

export default moduleRoutes
